import type { SelectedSlotDetail } from '../types'
import { CourtAvailabilitySelector } from './CourtAvailabilitySelector'

interface ScheduleStepProps {
  selectedModality: string | null
  selectedSlotDetails: SelectedSlotDetail[]
  onSelectSlots: (slots: SelectedSlotDetail[]) => void
  venueId: string
}

export function ScheduleStep({
  selectedModality,
  selectedSlotDetails,
  onSelectSlots,
  venueId
}: ScheduleStepProps) {
  return (
    <div className="flex flex-col h-full px-6 pt-6">
      <div className="space-y-6">
        <CourtAvailabilitySelector
          venueId={venueId}
          selectedModality={selectedModality}
          selectedSlotDetails={selectedSlotDetails}
          onSlotsChange={onSelectSlots}
        />
      </div>
    </div>
  )
}
